import common_translations from "../common.json";
import activities from "./activities.json";
import apac from "./apac.translation.json";
import app from "./app.json";
import cars from "./cars.json";
import checkout from "./checkout.json";
import exchange from "./exchange.json";
import fintech from "./fintech.json";
import flights from "./flights.json";
import hotels from "./hotels.json";
import packages from "./packages.json";
import rbcProvided from "./rbc.provided.json";
import rbc from "./rbc.translation.json";
import selfServe from "./self-serve.json";
import travelWishlists from "./travel-wishlists.json";
import traveler from "./traveler.json";
import trips from "./trips.json";
import ui from "./ui.json";
import wallet from "./wallet.json";

const bundle = {
  ...common_translations,
  ...app,
  ...flights,
  ...hotels,
  ...cars,
  ...ui,
  ...checkout,
  ...selfServe,
  ...trips,
  ...fintech,
  ...exchange,
  ...wallet,
  ...packages,
  ...traveler,
  ...travelWishlists,
  ...activities,
};

export default bundle;

export const frCA_defaultTranslations = bundle;

export const frCA_rbcTranslations = rbc;

export const frCA_rbcProvidedTranslations = rbcProvided;

export const frCA_checkoutTranslations = checkout;

export const frCA_activitiesTranslations = activities;

export const frCA_apacTranslations = apac;
